import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';
import { reelsReactionsConfig } from '../reelsReactions';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const reelsReactionsMVConfig: KpiType<typeof MediaViewerKpiLoader, typeof MediaViewerKPI> = {
    ...reelsReactionsConfig,
    name: 'kpi.facebook.reactions',
    id: 'reactions',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
